import { useEffect, useState } from "react";
import { i18n } from "../../../../localization/i18n";
import { IPartnerData } from "../../../../modules/Orders/CreateOrder/dtos";
import { LoadMore } from "../../../../modules/Orders/styles";
import api from "../../../../services/api";
import { showToast } from "../../../CustomToast";
import NoInfo from "../../../NoInfo";
import { PartnerItem } from "./components/PartnerItem";
import { Container, Footer } from "./styles";





export default function PartnerList(){
    
    const [licenseePartners, setLicenseePartners] = useState<IPartnerData[]>([])
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1)

    function loadMore() {
        setPage(page + 1);
      }

    async function GetLicenseePartners(){
        try{
            await api.get(`/partners?page=${page}`).then((response) => {
                setLicenseePartners([...licenseePartners, ...response.data.partners]);
                setTotalPage(response.data.total/10)
            })
        } catch(err){
            showToast({
                type: 'error',
                message: 'Não foi possivel carregar seus parceiros'
            })
        }
    }
    
    useEffect(() => {
        GetLicenseePartners()
    }, [page])
    
    
    return(
        <Container>
            {licenseePartners.map((patient) => {
                return(
                    <PartnerItem partner={patient}                        
                    />
                )
            })}
            {
                licenseePartners.length === 0 &&
                <NoInfo noInfo={`${i18n.t(`noInfo.partner`)}`}/>
            }
            <Footer>
                {page < totalPage ? (
                    <LoadMore onClick={loadMore}>Carregar mais...</LoadMore>
                ) : (
                    ""
                )}
            </Footer>
        </Container>
    )
}